import { render, staticRenderFns } from "./BackdropSidebar.vue?vue&type=template&id=1a463e81"
import script from "./BackdropSidebar.vue?vue&type=script&lang=js"
export * from "./BackdropSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports